module.exports = __webpack_public_path__ + "img/unclefarmer_man_thumb.d4223312.jpg";